import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import MobileMainLayout from './components/MobileMainLayout';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Flows from './pages/Flows';
import Leads from './pages/Leads';
import Profile from './pages/Profile';
import Advertisers from "./pages/Advertisers";
import Login from './pages/Login';
import LogoutPage from "./pages/LogoutPage";
import ForgotPassword from "./pages/ForgotPassword";
import MobileLogin from "./pages/MobileLogin";
import MobileForgotPassword from "./pages/MobileForgotPassword";
import { NotificationsProvider } from './context/NotificationsContext';
import MobileFlows from "./pages/MobileFlows";
import MobileLeads from "./pages/MobileLeads";
import MobileProfile from "./pages/MobileProfile";
import MobileAdvertisers from "./pages/MobileAdvertisers";

// Компонент для обработки уведомлений
// const NotificationHandler = () => {
//   const { notifications, unreadCount } = useNotification();
//
//   useEffect(() => {
//     console.log('Уведомления:', notifications);
//     console.log('Непрочитанные:', unreadCount);
//   }, [notifications, unreadCount]);
//
//   return null;
// };

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Используем MobileMainLayout для мобильных устройств, MainLayout для десктопа
  const MainLayoutComponent = isMobile ? MobileMainLayout : MainLayout;
  const LoginContent = isMobile ? MobileLogin : Login;
  const ForgotPasswordContent = isMobile ? MobileForgotPassword : ForgotPassword;
  const AdvertisersFlowsContent = isMobile ? MobileFlows : Flows;
  const AdvertisersLeadsContent = isMobile ? MobileLeads : Leads;
  const AdvertisersProfileContent = isMobile ? MobileProfile : Profile;
  const AdvertisersContent = isMobile ? MobileAdvertisers : Advertisers;
  // const WebmastersContent = isMobile ? MobileWebmasters : Webmasters;
  return (
        <NotificationsProvider>
            <MainLayoutComponent>
              <Routes>
                  <Route path="/login" element={<LoginContent />} />
                  <Route path="/forgot-password" element={<ForgotPasswordContent />} />
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <AdvertisersContent />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/logout"
                    element={
                      <ProtectedRoute>
                        <LogoutPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/advertisers/flows/:id"
                    element={
                      <ProtectedRoute>
                        <AdvertisersFlowsContent />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/advertisers/leads/:id"
                    element={
                      <ProtectedRoute>
                        <AdvertisersLeadsContent />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/advertisers/profile/:id"
                    element={
                      <ProtectedRoute>
                        <AdvertisersProfileContent />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/advertisers"
                    element={
                      <ProtectedRoute>
                        <AdvertisersContent />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<ProtectedRoute redirectDefault={true} />} />
              </Routes>
            </MainLayoutComponent>
      </NotificationsProvider>
  );
}

export default App;
